import template from "./valueTextToken.hbs";

export class ValueTextTokenElement extends HTMLElement {

  private _shadowRoot: ShadowRoot;
  private _icon: HTMLElement;

  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this.render();
  }

  private render() {
    this._shadowRoot.innerHTML = "";

    //Anadimos template HBS
    const templateHBS = document.createElement("template");
    templateHBS.innerHTML = template();
    this._shadowRoot.appendChild(templateHBS.content.cloneNode(true));

    this._icon = this._shadowRoot.querySelector("i");

    this.bindEvents();


    if (this.hasAttribute("readonly")) {
      this._icon.style.display = "none";
    }
  }

  private bindEvents(): void {
    this._icon.addEventListener("click", () => {
      this.dispatchEvent(new CustomEvent("removeToken",
        { bubbles: true },
      ))
    });
  }

  static get observedAttributes() { return ["readonly"]; }

  private attributeChangedCallback(name, oldValue, newValue) {
    this.render();
  }

  get data() {

    let slot = this._shadowRoot.querySelector(".container slot") as HTMLSlotElement;
    let nodes = slot.assignedNodes();

    let valueTextTokenElement = nodes[0].parentElement as ValueTextTokenElement;
    let value = valueTextTokenElement.getAttribute("value");

    return value;
  }
}

export function initValueTextTokenWebComponent() {
  window.customElements.define("s6-value-text-token", ValueTextTokenElement);
}
